import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/33_wonter_night/33_wonter_night"
 * Contains 1 texture(s)
 */
export class Mobile33WonterNightAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/33_wonter_night/33_wonter_night';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '33_wonter_night.png'
    ] as const;
}
